import {Columns} from 'compob2b-table';

export const YANDEX_FORM: Columns[] = [
  {
    key: 'token',
    title: 'OAuth token Яндекса',
    type: 'input',
    required: true,
    formly: true
  },
];
